import React from "react";

const Appointments = ({ appointmentDetails, isCounselor }) => {
  // Get today's date and time
  const today = new Date();
  const currentTime = today.getTime();  // Get the current time in milliseconds

  // Function to format a date as MM/DD/YYYY
  const formatDate = (date) => {
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  // Function to extract the date part (MM/DD/YYYY) from an appointment's full date string
  const extractDate = (appointmentDate) => {
    const date = new Date(appointmentDate); // Create Date object from the string
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  // Filter appointments based on isCounselor flag
  const filteredAppointments = appointmentDetails?.filter(appointment => appointment.IsCounselorApp === isCounselor);

  // Find today's appointment (the one closest to current time)
  const todaysAppointment = filteredAppointments?.find((appointment) => {
    const appointmentDate = new Date(appointment.AppointmentDate);
    const appointmentTime = new Date(`${appointmentDate.toDateString()} ${appointment.AppointmentTime}`).getTime();
    const appointmentDateString = extractDate(appointment.AppointmentDate);

    // Check if the appointment is today
    if (appointmentDateString === formatDate(today)) {
      return true; // Return the first match found (as it's sorted, this is the closest one)
    }
    return false;
  });

  // Find the most recent previous appointment (before today)
  let mostRecentPrevious = null;
  for (let i = filteredAppointments.length - 1; i >= 0; i--) {
    const appointment = filteredAppointments[i];
    const appointmentDate = new Date(appointment.AppointmentDate);
    const appointmentTime = new Date(`${appointmentDate.toDateString()} ${appointment.AppointmentTime}`).getTime();
    const appointmentDateString = extractDate(appointment.AppointmentDate);

    // If we find an appointment before today, set it as the most recent previous
    // console.log(appointmentDateString < formatDate(today), appointmentDateString, formatDate(today), filteredAppointments?.length );
    if (appointmentDateString < formatDate(today)) {

      mostRecentPrevious = appointment;
      break; // We break because we're going backwards through the list (sorted)
    }
  }

  // Find the next appointment (after today)
  const mostRecentNext = filteredAppointments?.find((appointment) => {
    // const appointmentDate = new Date(appointment.AppointmentDate);
    // const appointmentTime = new Date(`${appointmentDate.toDateString()} ${appointment.AppointmentTime}`).getTime();
    const appointmentDateString = extractDate(appointment.AppointmentDate);

    // Check if the appointment is after today
    if (appointmentDateString > formatDate(today)) {
      console.log(appointmentDateString > formatDate(today), appointmentDateString, formatDate(today));

      return true;
    }
    return false;
  });

  return { todaysAppointment, mostRecentPrevious, mostRecentNext, filteredAppointments };
};

export default Appointments;
